import { NgModule } from '@angular/core';
import {
  MdAutocompleteModule,
  MdButtonModule,
  MdButtonToggleModule,
  MdCardModule,
  MdCheckboxModule,
  MdDatepickerModule,
  MdInputModule,
  MdSelectModule,
  MdTabsModule,
  MdDialogModule,
  MdIconModule,
  MdProgressSpinnerModule,
  MdSnackBarModule,
  MdNativeDateModule,
  MdListModule,
  MdTooltipModule,
  MdProgressBarModule,
  MdSlideToggleModule
} from '@angular/material';



@NgModule({
  imports: [
  ],
  declarations: [

  ],
  providers: [
  ],
  exports: [
    MdAutocompleteModule,
    MdButtonModule,
    MdButtonToggleModule,
    MdCardModule,
    MdCheckboxModule,
    MdDatepickerModule,
    MdInputModule,
    MdSelectModule,
    MdTabsModule,
    MdNativeDateModule,
    MdDatepickerModule,
    MdInputModule,
    MdButtonModule,
    MdCardModule,
    MdSelectModule,
    MdIconModule,
    MdDialogModule,
    MdInputModule,
    MdSnackBarModule,
    MdProgressSpinnerModule,
    MdCheckboxModule,
    MdListModule,
    MdTooltipModule,
    MdProgressBarModule,
    MdSlideToggleModule
  ]
})

export class MaterialModule {}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/material/material.module.ts